import { SearchTravelModes } from '@/modules/Search/types'

export const DATE_FORMAT = 'dd/MM/yyyy'
export const TRAVEL_MODES: Array<SearchTravelModes> = [
  SearchTravelModes.Flight,
  SearchTravelModes.Hotel,
  SearchTravelModes.Car,
]

export const MAX_NUMBER_OF_BAGS = 2

export const NUMBER_OF_BAGS_OPTIONS = [
  { label: 'All', value: 'null' },
  { label: 0, value: 0 },
  { label: 1, value: 1 },
  { label: 2, value: 2 },
]
